import { reactive } from 'vue'

interface InfoBoxInstance {
  collapse: () => void
}

const activeInGroup = reactive<Record<string | symbol, InfoBoxInstance | null>>({})

export function useInfoBoxGroup() {
  const notifyExpand = (group: string | symbol, instance: InfoBoxInstance) => {
    const currentActive = activeInGroup[group]
    if (currentActive && currentActive !== instance) {
      currentActive.collapse()
    }
    activeInGroup[group] = instance
  }

  const collapseGroup = (group: string | symbol) => {
    const currentActive = activeInGroup[group]
    if (currentActive) {
      currentActive.collapse()
      activeInGroup[group] = null
    }
  }

  const clearActive = (group: string | symbol, instance: InfoBoxInstance) => {
    if (activeInGroup[group] === instance) {
      activeInGroup[group] = null
    }
  }

  return {
    notifyExpand,
    collapseGroup,
    clearActive,
  }
}
